export default {
    unit_type_event_delete_title: "Delete Event",
    unit_type_event_delete_success_message: "The event has been removed",
    unit_type_event_delete_message: "Are you sure you want to remove the selected unit type events?",
}